/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */


/**
 * An activity's `data` as an object.
 *
 * `ActivityFeedItem` did this for the props it hands its description; the render factory needs the
 * same view of the data one step earlier, to ask an activity type whether a given row is worth
 * rendering at all, so it lives here rather than in two copies.
 *
 * No path delivers a string today. The column is declared `json`, and the model decodes a json
 * property to an array on read, so what reaches the client is already an object. The string branch is
 * carried over from the code this replaces, where it guarded a model-generation regression: on
 * 2018-08-16 a regenerated model declared the column `string` for twenty minutes before the generator
 * bug was fixed, and a `string` declaration means the raw JSON text is handed through untouched. It
 * stays because that class of regression is silent — every line that reads a fact out of `data` would
 * degrade at once, with no error — and one type check is cheaper than the symptom.
 */
export const parseActivityData = (activity) => {
    const data = activity?.data;

    if (typeof data === 'string' || data instanceof String) {
        try {
            return JSON.parse(data) ?? {};
        } catch (e) {
            console.log('Could not parse Activity.data for activityId', activity?.activityId, e);
            return {};
        }
    }

    return data ?? {};
};
